// extracted by mini-css-extract-plugin
export default {"MainContainer":"Referrals_MainContainer__2Yhj9","userListContainer":"Referrals_userListContainer__X8Wfg","userListHead":"Referrals_userListHead__ulxVY"};